import React from 'react';
import { useClient } from '../../context/ClientContext';

export default function LocationCards({ locations }) {
  const { brand } = useClient();

  if (!locations || locations.length === 0) return null;

  return (
    <div>
      <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-4"
          style={{ fontFamily: brand.typography?.headerFont }}>
        Your Locations
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {locations.map(loc => (
          <LocationCard key={loc.name} location={loc} />
        ))}
      </div>
    </div>
  );
}

function LocationCard({ location }) {
  const { brand } = useClient();
  const { name, enquiries, costPerEnquiry, clicks } = location;

  return (
    <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-200 border border-gray-100 p-6">
      <div className="flex items-center gap-2 mb-4">
        <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
        <h4 className="text-lg font-semibold text-gray-900"
            style={{ fontFamily: brand.typography?.headerFont }}>
          {name}
        </h4>
      </div>

      <div className="space-y-3">
        <div>
          <p className="text-3xl font-bold" style={{ color: brand.colors?.primary }}>
            {enquiries}
          </p>
          <p className="text-sm text-gray-500">enquiries this month</p>
        </div>

        <div className="flex gap-6 pt-2 border-t border-gray-100">
          <div>
            <p className="text-sm font-semibold text-gray-900">
              ${costPerEnquiry > 0 ? costPerEnquiry.toFixed(0) : '\u2014'}
            </p>
            <p className="text-xs text-gray-500">per enquiry</p>
          </div>
          <div>
            <p className="text-sm font-semibold text-gray-900">{clicks}</p>
            <p className="text-xs text-gray-500">clicks</p>
          </div>
        </div>
      </div>
    </div>
  );
}
